import React, { useState, useMemo } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import Paginate from '../Paginate';

const BankStatements = ({ data, documentIndex = 0 }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);

  const transactions = useMemo(() => 
    data[documentIndex]?.bankFiFetchData?.Transactions.Transaction || 
    [], 
    [data, documentIndex]
  );

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return transactions?.slice(startIndex, startIndex + pageSize);
  }, [transactions, currentPage, pageSize]);

  const customerInfo = data[documentIndex]?.bankFiFetchData?.Profile?.Holders?.Holder;
  const accountInfo = data[documentIndex]?.bankFiFetchData?.Summary;

  const CustomerInfoSection = ({ label, value }) => (
    <p className="text-sm">
      <span className="font-semibold">{label}:</span>{' '}
      <span className="text-gray-700">{value}</span>
    </p>
  );
  console.log(accountInfo)

  return (
    <div className="w-full bg-white rounded-lg shadow-md">
      {loading && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white" />
        </div>
      )}

      <div className="p-6">
        <div className="flex justify-end pb-2">
          <span className="bg-blue-100 text-blue-500 px-3 py-1 rounded-full text-sm font-medium">
            Via Account Aggregator
          </span>
        </div>

        {/* Customer Information */}
        <div className="bg-slate-50 rounded-lg p-6 mb-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <CustomerInfoSection label="Account Holder Name" value={customerInfo?.name} />
              <CustomerInfoSection label="DOB" value={customerInfo?.dob} />
              <CustomerInfoSection label="Mobile" value={customerInfo?.mobile} />
              <CustomerInfoSection label="PAN" value={customerInfo?.pan} />
              <CustomerInfoSection label="Email" value={customerInfo?.email} />
              <CustomerInfoSection label="Address" value={customerInfo?.address} />
            </div>
            <div className="space-y-2">
              <CustomerInfoSection 
                label="Branch" 
                value={`${accountInfo?.branch}`} 
              />
              <CustomerInfoSection 
                label="Bank Account Type" 
                value={accountInfo?.type || accountInfo?.accountType} 
              />
              <CustomerInfoSection 
                label="Account Number" 
                value={data[documentIndex]?.fiObjects?.[0]?.maskedAccNumber || data[documentIndex]?.accountNumber} 
              />
              <CustomerInfoSection label="IFSC" value={accountInfo?.ifscCode} />
            
              <CustomerInfoSection label="Reference No." value={ data[documentIndex]?.linkAccountRefNo} />
            </div>
          </div>
        </div>

        {/* Transactions Table */}
        {transactions.length>0?
        <div className="bg-white rounded-lg">
          <div className="mb-4">
            <h2 className="text-lg font-semibold">Transactions</h2>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-slate-50">
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Txn ID</th>
                  <th className="px-4 py-3 text-right text-sm font-semibold text-gray-900">Amount(₹)</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Type</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Narration</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Date&Time</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Mode</th>
                  <th className="px-4 py-3 text-right text-sm font-semibold text-gray-900">Current Balance(₹)</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {paginatedData.map((txn, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-gray-900">{txn.txnId}</td>
                    <td className="px-4 py-3 text-sm text-gray-900 text-right">{Math.abs(txn.amount)}</td>
                    <td className="px-4 py-3 text-sm text-gray-900 capitalize">{txn.category || txn.type}</td>
                    <td className="px-4 py-3 text-sm text-gray-900">{txn.narration}</td>
                    <td className="px-4 py-3 text-sm text-gray-900">{txn.date || txn.valueDate}</td>
                    <td className="px-4 py-3 text-sm text-gray-900 capitalize">{txn.mode}</td>
                    <td className="px-4 py-3 text-sm text-gray-900 text-right">{txn.balance || txn.currentBalance}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-4">
            <Paginate
              currentPage={currentPage}
              totalItems={transactions.length}
              pageSize={pageSize}
              onPageChange={setCurrentPage}
              onPageSizeChange={setPageSize}
            />
          </div>
        </div>:
        <p>No transactions found</p>}
      </div>
    </div>
  );
};

export default BankStatements;